import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as BrowserRouter } from 'react-router-dom';
   // 在你的入口文件中（如 index.js 或 App.js）
import Dotenv from 'dotenv-webpack';

import './index.css';
import App from './App';

// if (process.env.NODE_ENV === 'development') {
//   console.log('development');
//   require('dotenv').config({ path: '.env.development' });
// } else {
//   require('dotenv').config({ path: '.env.production' });
// }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 